const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57.59"
    height="47.41"
    viewBox="0 0 57.59 47.41"
  >
    <path
      d="M21.712,42.995,8.059,28.252,3.41,33.237,21.712,53,61,10.575,56.384,5.59Z"
      transform="translate(-3.41 -5.59)"
      fill="#b04fc1"
    />
  </svg>
);

export default CheckIcon;
